// features/finance/finance-routes.ts
import { APP_ROUTES } from '../../../app-routes';

export const FINANCE_ROUTES = {
  Reports: '',
  Invoices: 'invoices',
  RefundTickets: 'refund-tickets',
  Shifts: 'shifts'
};

export const FinancePaths = {
  Reports: `/${APP_ROUTES.Reports}`,
  Invoices: `/${APP_ROUTES.Invoices}`,
  RefundTickets: `/${APP_ROUTES.RefundTickets}`,
  Shifts: `/${APP_ROUTES.Shifts}`
};
